var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-notifications"},[(_vm.dialogActive)?_c('user-notifications-dialog',{attrs:{"type":_vm.dialogType,"item-id":_vm.dialogItemId},on:{"closed":_vm.toggleDialog}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }